var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { UserDeviceService } from '~/services/management-service/user-device.service';
var FacilityManage = /** @class */ (function (_super) {
    __extends(FacilityManage, _super);
    function FacilityManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userObj = {};
        _this.dataSet = [];
        return _this;
    }
    FacilityManage.prototype.refresh = function (obj) {
        var _this = this;
        var deviceModel = {
            userIds: [obj.id]
        };
        this.userDeviceService.getAllDevices(deviceModel).subscribe(function (data) {
            _this.dataSet = data;
            _this.userObj = obj;
        });
        this.dataSet = obj.userDevices;
    };
    /**
     * 启用禁用设备
     */
    FacilityManage.prototype.hangleFacility = function (scope, handle) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u5BF9\u7528\u6237" + this.userObj.realName + "\u6267\u884C\u8BE5\u64CD\u4F5C\u5417\uFF1F", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            var hangleFacility = {
                userIds: [_this.userObj.id],
                deviceType: scope.row.deviceType,
                deviceStatus: handle,
            };
            _this.userDeviceService.disableDevice(hangleFacility).subscribe(function (data) {
                scope.row.deviceStatus = handle;
                // 更新数据信息
                _this.$message.success('操作成功');
            });
        });
    };
    /**
     * 启用停用设备锁
     */
    FacilityManage.prototype.hangleLock = function (scope, handle) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u5BF9\u7528\u6237" + this.userObj.realName + "\u6267\u884C\u8BE5\u64CD\u4F5C\u5417\uFF1F", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            var hangleLock = {
                userIds: [_this.userObj.id],
                deviceType: scope.row.deviceType,
                deviceValidate: handle,
            };
            _this.userDeviceService.enableDeviceKey(hangleLock).subscribe(function (data) {
                scope.row.deviceValidate = handle;
                // 更新数据信息
                _this.$message({
                    type: 'success',
                    message: '操作成功!',
                });
            });
        });
    };
    /**
     * 重置设备
     */
    FacilityManage.prototype.resetfacility = function (scope) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u5BF9\u7528\u6237" + this.userObj.realName + "\u6267\u884C\u8BE5\u64CD\u4F5C\u5417\uFF1F", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            _this.userDeviceService
                .resetDevice({
                userIds: [_this.userObj.id],
                deviceType: scope.row.deviceType,
                deviceValidate: 'DISABLED',
                deviceStatus: 'DISABLED',
            })
                .subscribe(function (data) {
                scope.row.code = '';
                // 更新数据信息
                _this.$message({
                    type: 'success',
                    message: '操作成功!',
                });
            });
        });
    };
    __decorate([
        Dependencies(UserDeviceService)
    ], FacilityManage.prototype, "userDeviceService", void 0);
    FacilityManage = __decorate([
        Component({
            components: {},
        })
    ], FacilityManage);
    return FacilityManage;
}(Vue));
export default FacilityManage;
